import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import ClockInOutWidget from '../components/ClockInOutWidget';

/**
 * Landing page reached by scanning the gate QR code — the poster encodes
 * a URL like /staff-clock-in?token=XXXX, which a phone's native camera app
 * opens directly. The token is passed through to the clock-in/out calls so
 * the backend can verify it was actually this scan that triggered the action.
 */
function StaffClockInPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return (
    <Layout>
      <div className="page" style={{ maxWidth: 420, margin: '0 auto' }}>
        <div className="page-header">
          <div>
            <h1>Clock In / Out</h1>
            <p>{token ? 'Scanned from the school entrance.' : 'No QR code detected — this only works from the button in your portal unless your school requires scanning.'}</p>
          </div>
        </div>
        <ClockInOutWidget qrToken={token} />
      </div>
    </Layout>
  );
}

export default StaffClockInPage;
